<template>
    <div class="search-result">
        <div class="image">
            <b-img src="@/assets/default-product.png" />
        </div>
        <div class="content">
            <div class="title">{{ title }}</div>
            <ul class="product-codes">
                <li v-if="productInfo && productInfo.ean">EAN: {{ productInfo.ean }}</li>
                <li v-if="productInfo && productInfo.upc">UPC: {{ productInfo.upc }}</li>
                <li v-for="extra_id in extraIDs" :key="extra_id.id">{{ extra_id.type.name }}: {{ extra_id.value }}</li>
            </ul>
            <div class="spacer"/>
            <div class="footer">
                <div class="price">
                    <span v-if="productCount > 1">de la</span>
                    {{ parseFloat(price).toFixed(2) }} {{ currency }}/buc
                </div>
                <div v-if="supplier" class="stock">{{ supplier }}</div>
                <div v-else-if="supplierCount === 1" class="stock">{{ supplierCount }} furnizor</div>
                <div v-else class="stock">{{ supplierCount }} furnizori</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SearchResult",
        props: [
            'title',
            'productInfo',
            'extraIDs',
            'supplierCount',
            'productCount',
            'price',
            'currency',
            'supplier'
        ]
    }
</script>

<style scoped>
    .search-result {
        background: white;
        border: 1px solid #CDCDCD;
        display: flex;
        padding: 3px;
    }

    .search-result:hover {
        background: #fafafa;
    }

    .image {
        margin: 3px;
        border: solid 1px grey;
        padding: 3px;
        height: 70px;
        width: 70px;
    }

    .image img {
        height: 100%;
    }

    .content {
        margin-left: 5px;
        flex-grow: 1;

        display: flex;
        flex-direction: column;

        padding-right: 3px;
    }

    .spacer {
        flex-grow: 1;
    }

    .title {
        font-size: 18px;
    }

    .product-codes {
        margin: 0;
        padding: 0;
        list-style-type: none;

        color: #6F6F6F;
        font-size: 12px;
    }

    .product-codes li {
        display: inline-block;
    }
    .product-codes li:not(:last-child) {
        margin-right: 10px;
    }

    .footer {
        display: flex;
        justify-content: space-between;
    }

    .price {
        color: #ff0000;
        font-weight: 800;
    }

    .stock {
        color: #6F6F6F;
        font-weight: 600;
    }
</style>